import React from "react";
import { Stack } from "@mui/material";
import MerchantDocumentUpload from "../../offline-merchant-detail/merchant-document-upload/MerchantDocumentUpload";
// import KycStatusSection from "../../offline-merchant-detail/kyc-status/KycStatusSection";

// Simple component, no memoization to avoid potential circular init issues
export default function KycStatusAndDocumentUploadSection({
  merchant,
  merchantId,
}) {
  const resolvedMerchantId = merchant?.merchantId || merchantId;
  return (
    <Stack gap={3}>
      {/* <KycStatusSection merchant={merchant} /> */}
      {/* <Divider /> */}
      <MerchantDocumentUpload merchantId={resolvedMerchantId} />
    </Stack>
  );
}
